<template>
      <div class="col-sm-3 col-12 app-border-right app-border-top pr-md-4">

                <h6 class="font-weight-bold description-header mt-2">Top Devices</h6>

                <div v-for="(device,index) in devices" :key="device.name" class="pt-2 d-flex flex-nowrap justify-content-between align-items-center">
                  <div class="w-50" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    <i :class="'text-' + getColor(index)" class="fas fa-circle nav-icon mr-2"></i>{{device.name}}
                  </div>

                  <div class="progress progress-sm flex-grow-2 mr-4" style="width: 55%">
                    <div :class="'bg-' + getColor(index)" class="progress-bar" :style="{width: device.percentage + '%'}"></div>
                  </div>

                  <div >{{device.percentage + '%'}}</div>
                </div>
              </div>

</template>

<script>

export default {

   props: {
    devices:{
    type: Array,
    require: true
    }
  },


  methods:{

    getColor(index){

      return [
        'info',
        'success',
        'danger',
        'warning',
        'secondary',
        'default',
      ][index]
    }



  },

}
</script>

<style scoped>
/* Medium Devices, Desktops */
@media only screen and (min-width : 992px) {
.app-border-right {
    border-right: 1px solid #dee2e6 !important;
}
}

 /* Extra Small Devices, Phones */ 
@media only screen and (max-width : 480px) {
  .app-border-top {
    border-top: 1px solid #dee2e6 !important;
    margin-top: 20px;
    padding-top: 20px;
}
}
</style>